<template>
    <!--集采采购商管理-->
    <div>
        <div class="container">
            <e-search
                    :data="filterInfo.data"
                    :field-list="filterInfo.fieldList"
                    :list-type-info="listTypeInfo"
                    @handleFilter="handleFilter"
                    @handleReset="handleReset"
            ></e-search>
        </div>
        <div class="container">
            <tableList
                    rowKey="id"
                    :indexShow="indexShow"
                    :table-data="tableData"
                    :table-label="tableLabel">
                <template v-slot:operate="slot">
                    <eui-btn type="text" @click="viewDetail(slot.scope.row.sourcingCustomizationId)">查看详情</eui-btn>
                    <eui-btn type="text" @click="addInformation(slot.scope.row.sourcingCustomizationId)" v-if="Number(slot.scope.row.status) === 0">补充信息</eui-btn>
<!--                    slot.scope.row.-->
                    <div></div>
                </template>
            </tableList>
            <div class="pagination flex-end">
                <el-pagination
                        background
                        :page-sizes="[10, 20]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="queryData.pageNum"
                        :page-size="queryData.pageSize"
                        :total="pageTotal"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"/>
            </div>
        </div>
    </div>
</template>

<script>
  import eSearch from '../../components/common/e-search';
  import tableList from '../../components/common/e-table-list';
  import api from '../../api/order';
  export default {
    components: {
      eSearch,
      tableList,
    },
    data(){
      return{
        indexShow:true,
        checked:false,
        filterInfo: {
          data: {
            sourcingCustomizationNo:null,
            productSkuName:null,
            purchaseCompanyName:null,
            status:null,
          },
          fieldList: [
            {label: '定制单号', type: 'input', value: 'sourcingCustomizationNo'},
            {label: '产品名称', type: 'input', value: 'productSkuName'},
            {label: '采购商名称', type: 'input', value: 'purchaseCompanyName'},
            {label: '定制状态', type: 'select', value: 'status', list: 'statusList'},
          ],
        },
        listTypeInfo:{
          statusList:[
            { name: '全部', id: null },
            { name: '待确认', id: 0 },
            { name: '已确认', id: 1 },
          ],
        },
        tableData: [],
        tableLabel: [
          {label: "定制单号", param: "sourcingCustomizationNo", align: "center",},
          {label: "产品名称", param: "productSkuName", align: "center",},
          {label: '采购商名称', param: 'purchaseCompanyName', align: 'center',},
          {
            label: "定制时间", param: "createTime", align: "center",width:'100',
            render({createTime}) {
              return createTime.split(' ')[0];
            }
          },
          {label: "定制状态", param: "statusDesc", align: "center",},
          {label: '操作', param: '', align: 'center',slot:'operate'},
        ],
        queryData:{
          sourcingCustomizationNo:null,
          productSkuName:null,
          purchaseCompanyName:null,
          status:null,
          pageNum:1,
          pageSize:10,
          pageTotal:0,
        },
        pageTotal:0,
      }
    },
    methods:{
      addInformation(sourcingCustomizationId){
        this.$router.push({ path: '/customizedDetail' ,query:{sourcingCustomizationId:sourcingCustomizationId,flag:'addInformation'}})
      },
      viewDetail(sourcingCustomizationId){
        this.$router.push({ path: '/customizedDetail' ,query:{sourcingCustomizationId:sourcingCustomizationId,flag:'viewDetail'}})
      },
      handleCurrentChange(val){
        this.queryData.pageNum = val;
        this.sourcingCustomizationSupplierPage();
      },
      handleSizeChange(val){
        this.queryData.pageNum = 1;
        this.queryData.pageSize = val;
        this.sourcingCustomizationSupplierPage();
      },
      handleFilter(val){
        this.queryData.sourcingCustomizationNo = val.sourcingCustomizationNo;
        this.queryData.productSkuName = val.productSkuName;
        this.queryData.purchaseCompanyName = val.purchaseCompanyName;
        this.queryData.status = val.status;
        this.queryData.pageNum = 1;
        this.sourcingCustomizationSupplierPage();
      },
      handleReset(){
        this.queryData = {
          sourcingCustomizationNo:null,
          productSkuName:null,
          purchaseCompanyName:null,
          status:null,
          pageNum: 1,
          pageSize: 10,
        };
        this.sourcingCustomizationSupplierPage();
      },
      async sourcingCustomizationSupplierPage(){
        const res = await api.sourcingCustomizationSupplierPage(this.queryData);
        if(res.success){
          this.tableData = res.data.records || [];
          this.pageTotal = res.data.total;
        }
      },
    },
    mounted() {
        this.sourcingCustomizationSupplierPage();
    }


  }
</script>

<style scoped lang="scss">

</style>